import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import { SelectOption } from '@form';
import {
  PopoverComponent,
  ButtonComponent,
  IconComponent,
  FilterSwitchComponent
} from '@ui';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'ui-switch-multiple',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ PopoverComponent, ButtonComponent, IconComponent, TranslocoDirective, FilterSwitchComponent],
  template: `
        <ui-popover
          placement="bottom"
          [visible]="visible()"
          (popoverVisibleChange)="setVisiblePopover($event)"
          *transloco="let t"
        >
          <!-- Popover trigger -->
          <ui-button buttonType="dashed">
            <ui-icon icon="filter" />
            {{ titelButton() }}
          </ui-button>
          <!-- The content of the popover is provided as a template -->
          <div popover-content class="w-[112px]">

            @for (option of options(); track option.value) {
              <ui-filters-switch (onCheck)="handleShowOptionToFilter($event, option.value)" [selected]='false'>
                  {{ t(option.label) }}
              </ui-filters-switch>
            }
          </div>
        </ui-popover>
  `,
})
export class SwitchMultipleComponentComponent {
  options = input.required<ReadonlyArray<SelectOption>>();
  titelButton = input.required<string>();
  visible = signal<boolean>(false);
  onCheck = output<boolean>();
  selectedData = output<string[]>();
  optionsSelected = signal<string[]>([]);
  witdh = input<string>('112px');

  setVisiblePopover(visible: boolean) {
    this.optionsSelected.set(this.options().map((option)=> option.value))
    this.visible.set(visible);
  }

  handleShowOptionToFilter(checked: boolean, optionsSelected: string) {
    if (checked === true) {
      // Add only if not already present
      const current = this.optionsSelected();
      if (!current.includes(optionsSelected)) {
        this.optionsSelected.set([...current, optionsSelected]);
      }
    } else {
      this.optionsSelected.set(
        this.optionsSelected().filter((priorityItem) => priorityItem !== optionsSelected)
      );
    }
    this.selectedData.emit(this.optionsSelected());
  }
}
